import React from 'react';
import PropTypes from 'prop-types';
import { Image } from '/components/core/Image';
import { H2, Paragraph } from '/components/core/Typography';
import ReadMoreButton from '../../core/ReadMoreButton/ReadMoreButton';
import classnames from 'classnames';

function PSPSectionHeader({ content, additionalProps, showReadmore }) {
  const { image, alt, header, description } = content;
  const { heading, paragraph } = additionalProps || {};

  const renderParagraphs = () =>
    description.map((text, index) => <Paragraph key={index} {...paragraph}>{text}</Paragraph>);

  return (
    <div>
      <Image src={image} alt={alt} />
      <H2 {...heading}>{header}</H2>

      <div className={classnames('hide-for-desktop',{'hide-for-mobile': showReadmore })}>
        <ReadMoreButton>
          {renderParagraphs()}
        </ReadMoreButton>
      </div>

      <div className={classnames({ 'hide-for-mobile': !showReadmore})}>
        {renderParagraphs()}
      </div>
    </div>
  );
}

PSPSectionHeader.propTypes = {
  content: PropTypes.object.isRequired,
  additionalProps: PropTypes.object,
  showReadmore: PropTypes.bool,
};
PSPSectionHeader.defaultProps = {
    additionalProps: {},
    showReadmore: false,
  };
export default PSPSectionHeader;